
export const HeaderTitle = ({title, className}) => {
    
    return (
        <div className="horizontal phone-user-card">
              <h5 className={`screen-title ${className}`} style={{ flexGrow: 1 }}>{title}</h5>
        </div>
    )
}
